import router, { resetRouter } from "./router";
import store from "./store";
// import storage from "store";
import NProgress from "nprogress"; // progress bar
import "@/components/NProgress/nprogress.less"; // progress bar custom style
import notification from "ant-design-vue/es/notification";
import { setDocumentTitle, domTitle } from "@/utils/domUtil";
import { ACCESS_TOKEN, USER_INFO, LOGIN_FROM } from "@/store/mutation-types";
// import {feishu} from "./utils/h5-js-sdk-1.5.16"
// import {vconsole} from "./utils/vconsole.min.js"
import { getToken, getUserInfo } from "./api/LogonFree.js";
// import { i18nRender } from '@/locales'

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const loginRoutePath = "/login";
// const defaultRoutePath = '/dashboard/workplace'
const defaultRoutePath = "/visit/reservation";

const redirectRoutePath = "/redirect";

router.beforeEach((to, from, next) => {
  NProgress.start(); // start progress bar
  // to.meta && typeof to.meta.title !== 'undefined' && setDocumentTitle(`${i18nRender(to.meta.title)} - ${domTitle}`)
  to.meta &&
    typeof to.meta.title !== "undefined" &&
    setDocumentTitle(`${to.meta.title} - ${domTitle}`);
  /* has token */
  const token = sessionStorage.getItem(ACCESS_TOKEN);
  console.log('token', token);
  if (token) {
    if (to.path === loginRoutePath) {
      next({ path: defaultRoutePath });
      NProgress.done();
    } else {
      // check login user.roles is null
      if (store.getters.roles.length === 0) {
        // request login userInfo
        store
          .dispatch("GetInfo")
          .then((res) => {
            // 根据用户权限信息生成可访问的路由表
            store.dispatch("GenerateRoutes", { token, ...res }).then(() => {
              // 动态添加可访问路由表
              // VueRouter@3.5.0+ New API
              resetRouter(); // 重置路由 防止退出重新登录或者 token 过期后页面未刷新，导致的路由重复添加
              store.getters.addRouters.forEach((r) => {
                router.addRoute(r);
              });
              // 请求带有 redirect 重定向时，登录自动重定向到该地址
              const redirect = decodeURIComponent(
                from.query.redirect || to.path
              );
              if (to.path === redirect) {
                // set the replace: true so the navigation will not leave a history record
                next({ ...to, replace: true });
              } else {
                // 跳转到目的路由
                next({ path: redirect });
              }
            });
          })
          .catch((e) => {
            console.log(e);
            notification.error({
              message: "错误",
              description: "请求用户信息失败，请重试",
            });
          });
      } else {
        next();
      }
    }
  } else {
    if (to.path === redirectRoutePath) {
      if (to.query) {
        getToken(to.query.code).then((res) => {
          console.log(res);
          sessionStorage.setItem(ACCESS_TOKEN, res.data);
          getUserInfo().then((res3) => {
            sessionStorage.setItem(USER_INFO, JSON.stringify(res3.data));
            next({ path: "/" });
          });
        });
      }
      
    } else if (to.path === loginRoutePath) {
      sessionStorage.setItem(LOGIN_FROM, "ip");
      next({ path: "/user/login" });
    }
    else if (to.path === "/user/login") {
      sessionStorage.setItem(LOGIN_FROM, "ip");
      next();
    }
    else {
      // 如果token为空则跳转至sso登录页面
      //window.location.href = "https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=https://jh-test.handiansoft.net/redirect&app_id=cli_a3e6118945fa100d&state=123456";
      window.location.href = process.env.FS.REDIRECT.URL;
    }
    

    // getToken("code").then((res) => {
    //   console.log(res);
    //   sessionStorage.setItem(ACCESS_TOKEN, res.data);
    //   getUserInfo().then((res3) => {
    //     sessionStorage.setItem(USER_INFO, JSON.stringify(res3.data));
    //     next({ path: "/hourSystem" });
    //   });
    // });

    // sessionStorage.setItem(ACCESS_TOKEN, "test");
    // next({ path: "/hourSystem" });

    // if (!window.h5sdk) {
    //   console.log('invalid h5sdk')
    //   alert('please open in feishu')
    //   return
    // }
    // getAppId().then(res => {
    //   console.log(res.data)
    //   window.h5sdk.error(err => {
    //     throw ('h5sdk error:', JSON.stringify(err));
    //   });
    //   window.h5sdk.ready(() => {
    //     console.log("window.h5sdk.ready");
    //     console.log("url:", window.location.href);
    //     // 调用JSAPI tt.requestAuthCode 获取 authorization code
    //     tt.requestAuthCode({
    //       appId: res.data,
    //       // 获取成功后的回调
    //       success(res) {
    //         console.log("getAuthCode succeed");
    //         //authorization code 存储在 res.code
    //         // 此处通过fetch把code传递给接入方服务端Route: callback，并获得user_info
    //         // 服务端Route: callback的具体内容请参阅服务端模块server.py的callback()函数
    //         getToken(res.code).then(res2 => {
    //           // user+token+menu
    //           console.log("getToken succeed=>"+res2);
    //           getUserInfo(res2.data).then(res3=>{
    //             sessionStorage.setItem(ACCESS_TOKEN, res2.data)
    //             sessionStorage.setItem(USER_INFO,JSON.stringify(res3.data))
    //             next({ path: "/hourSystem"});
    //           })
    //         }).catch(function (e)
    //           {
    //             console.error(e)
    //           })
    //       },
    //       // 获取失败后的回调
    //       fail(err) {
    //         console.log(`getAuthCode failed, err:`, JSON.stringify(err));
    //       }
    //     })
    //   })

    // })

    // } else {
    //   next({ path: loginRoutePath, query: { redirect: to.fullPath } });
    //   NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
    // }
  }
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});
